import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=3b36cd2e&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=3b36cd2e&prod&scoped=true&lang=css&"
import style1 from "./notes.vue?vue&type=style&index=1&id=3b36cd2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b36cd2e",
  null
  
)

export default component.exports